import { MarketingHero } from "@/components/marketing-hero";
import { MarketingPageShell } from "@/components/marketing-page-shell";
import { HomepageAgentInstall } from "@/components/setup/homepage-agent-install";
import {
	PLATFORM_LIGHT_COLOR_MAP,
	PlatformIcon,
} from "@/components/social-platform-logos";

export function PlatformSchedulerPage({
	platform,
	platformLabel,
	hero,
}: {
	platform: string;
	platformLabel: string;
	hero: { title: string; description: string };
}) {
	const color = PLATFORM_LIGHT_COLOR_MAP[platform] ?? "text-foreground";
	const titlePunctuation = hero.title.match(/[.!?]+\s*$/)?.[0].trim() ?? "";
	const titleText = hero.title.replace(/[.!?]+\s*$/, "");
	const lastSpace = titleText.lastIndexOf(" ");
	const titleLead = lastSpace > 0 ? titleText.slice(0, lastSpace) : "";
	const titleTail = lastSpace > 0 ? titleText.slice(lastSpace + 1) : titleText;
	const iconSize = platform === "linkedin" ? "size-full" : "size-[60%]";

	return (
		<MarketingPageShell>
			<MarketingHero
				eyebrow={`${platformLabel} channel`}
				title={
					<>
						{titleLead && <>{titleLead} </>}
						<span className="inline-flex items-center gap-3 whitespace-nowrap">
							{titleTail}
							{titlePunctuation}
							<span
								className={`relative inline-flex size-[1.1em] shrink-0 -rotate-[6deg] items-center justify-center overflow-hidden rounded-[22%] bg-white align-middle shadow-[0_3px_10px_rgba(0,0,0,0.12),0_0_0_1px_rgba(0,0,0,0.06)] ${color}`}
							>
								<PlatformIcon platform={platform} className={iconSize} />
							</span>
						</span>
					</>
				}
				description={hero.description}
			/>

			<HomepageAgentInstall />
		</MarketingPageShell>
	);
}
